export default {
  get: {
    funKey: 'get',
    name: '查看',
    apis: [
      { method: 'GET', path: '/internalcontrol/purchase_method_batch/detail/info' },
    ]
  },
  getByAuth: {
    funKey: 'getByAuth',
    name: '查看权限内的',
    apis: [
      { method: 'GET', path: '/internalcontrol/purchase_method_batch/detail/info/by_auth' },
    ]
  }
}